import React, { useEffect, useState } from 'react';
import AuthHeader from '../../components/Navbar/AuthHeader';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";

import ReactFlagsSelect from "react-flags-select";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import countries from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";
import { FaArrowLeftLong } from "react-icons/fa6";
import ProgressSteps from '../../components/ProgressStep/ProgressSteps';
import { LuFileText } from "react-icons/lu";
import { IoMdEyeOff } from "react-icons/io";
import { IoEye } from "react-icons/io5";

import { registerUser } from '../../actions/auth';
import { fetchSupportedCountryStates } from '../../actions';
import { toast } from 'react-toastify';
import { Capacitor } from '@capacitor/core';
import { Device } from '@capacitor/device';

// Register the locale
countries.registerLocale(enLocale);

// Generate a mapping of country codes to their full names
const countryNames = countries.getNames("en", { select: "official" });

const countryStates = {
    NG: [ // Nigeria 🇳🇬
        "Abia", "Adamawa", "Akwa Ibom", "Anambra", "Bauchi", "Bayelsa", "Benue", "Borno", 
        "Cross River", "Delta", "Ebonyi", "Edo", "Ekiti", "Enugu", "Gombe", "Imo", "Jigawa", 
        "Kaduna", "Kano", "Katsina", "Kebbi", "Kogi", "Kwara", "Lagos", "Nasarawa", "Niger", 
        "Ogun", "Ondo", "Osun", "Oyo", "Plateau", "Rivers", "Sokoto", "Taraba", "Yobe", "Zamfara", 
        "Federal Capital Territory (Abuja)"
    ],
    GH: [ // Ghana 🇬🇭
        "Ahafo", "Ashanti", "Bono", "Bono East", "Central", "Eastern", "Greater Accra", 
        "North East", "Northern", "Oti", "Savannah", "Upper East", "Upper West", "Volta", "Western", "Western North"
    ],
    ZA: [ // South Africa 🇿🇦
        "Eastern Cape", "Free State", "Gauteng", "KwaZulu-Natal", "Limpopo", 
        "Mpumalanga", "North West", "Northern Cape", "Western Cape"
    ],
    KE: [ // Kenya 🇰🇪
        "Baringo", "Bomet", "Bungoma", "Busia", "Elgeyo-Marakwet", "Embu", "Garissa", "Homa Bay", 
        "Isiolo", "Kajiado", "Kakamega", "Kericho", "Kiambu", "Kilifi", "Kirinyaga", "Kisii", 
        "Kisumu", "Kitui", "Kwale", "Laikipia", "Lamu", "Machakos", "Makueni", "Mandera", 
        "Marsabit", "Meru", "Migori", "Mombasa", "Murang'a", "Nairobi City", "Nakuru", 
        "Nandi", "Narok", "Nyamira", "Nyandarua", "Nyeri", "Samburu", "Siaya", "Taita Taveta", 
        "Tana River", "Tharaka-Nithi", "Trans Nzoia", "Turkana", "Uasin Gishu", "Vihiga", "Wajir", "West Pokot"
    ],
    EG: [ // Egypt 🇪🇬
        "Alexandria", "Aswan", "Asyut", "Beheira", "Beni Suef", "Cairo", "Dakahlia", "Damietta", 
        "Faiyum", "Gharbia", "Giza", "Ismailia", "Kafr El Sheikh", "Luxor", "Matruh", "Minya", 
        "Monufia", "New Valley", "North Sinai", "Port Said", "Qalyubia", "Qena", "Red Sea", 
        "Sharqia", "Sohag", "South Sinai", "Suez"
    ],
    MW: [ // Malawi 🇲🇼
        "Balaka", "Blantyre", "Chikwawa", "Chiradzulu", "Chitipa", "Dedza", "Dowa", "Karonga", 
        "Kasungu", "Likoma", "Lilongwe", "Machinga", "Mangochi", "Mchinji", "Mulanje", 
        "Mwanza", "Mzimba", "Neno", "Nkhata Bay", "Nkhotakota", "Nsanje", "Ntcheu", 
        "Ntchisi", "Phalombe", "Rumphi", "Salima", "Thyolo", "Zomba"
    ],
    AO: [ // Angola 🇦🇴
        "Bengo", "Benguela", "Bié", "Cabinda", "Cuando Cubango", "Cuanza Norte", "Cuanza Sul", 
        "Cunene", "Huambo", "Huíla", "Luanda", "Lunda Norte", "Lunda Sul", "Malanje", 
        "Moxico", "Namibe", "Uíge", "Zaire"
    ],
    MA: [ // Morocco 🇲🇦
        "Tanger-Tétouan-Al Hoceïma", "Oriental", "Fès-Meknès", "Rabat-Salé-Kénitra", 
        "Béni Mellal-Khénifra", "Casablanca-Settat", "Marrakech-Safi", "Drâa-Tafilalet", 
        "Souss-Massa", "Guelmim-Oued Noun", "Laâyoune-Sakia El Hamra", "Dakhla-Oued Ed-Dahab"
    ]
};



function PersonalInformation() {
    const account_type = localStorage.getItem('account_type');
    const email = localStorage.getItem('email');
    const ref_code = localStorage.getItem('referral_code');
    const navigate = useNavigate();

    useEffect(() => {
        if (!email || !account_type) {
            navigate('/getstarted', { replace: true });
        }
    }, [email, account_type, navigate]);

    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        email: email || '',
        account_type: account_type,
        password: '',
        password_confirmation: '',
        province: '',
        referral_code: ref_code ? ref_code : '',
        ...(account_type === 'business' && { business_name: '' }),
    });
    const [selectedCountry, setSelectedCountry] = useState('NG');
    const [phone, setPhone] = useState('');
    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const dispatch = useDispatch();
    const [passwordType, setPasswordType] = useState("password");
    const [stateLoading, setStateLoading] = useState(false);

    const togglePasswordVisibility = (setter, currentType) => {
        setter(currentType === 'password' ? 'text' : 'password');
    };
    const {allowedCountries, supportedCountryDetails} = useSelector((state) => state.country);
    const allowedCountryCodes = allowedCountries.map((code) => code.toUpperCase());
    // console.log(allowedCountries)

    const publicUrl = process.env.REACT_APP_PUBLIC_URL;


    // Password validation checks
    const passwordCriteria = [
        { id: 1, text: "At least 8 characters", isValid: (pass) => pass.length >= 8 },
        { id: 2, text: "1 uppercase character", isValid: (pass) => /[A-Z]/.test(pass) },
        { id: 3, text: "1 lowercase character", isValid: (pass) => /[a-z]/.test(pass) },
        { id: 4, text: "1 number", isValid: (pass) => /[0-9]/.test(pass) },
        { id: 5, text: "1 special character", isValid: (pass) => /[!@#$%^&*(),.?":{}|<>]/.test(pass) }
    ];

    const validatePassword = () => {
        if (!passwordCriteria.every(criteria => criteria.isValid(formData.password))) {
            setErrorMessage("Password does not meet the required criteria.");
            setTimeout(() => setErrorMessage(""), 5000);
            return false;
        }
        if (formData.password.trim() !== formData.password_confirmation.trim()) {
            setErrorMessage("Passwords do not match.");
            setTimeout(() => setErrorMessage(""), 5000);

            return false;
        }
        return true;
    };
    
    // Handle input change
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    

    // Handle form submission
    const handleSignup = async (event) => {
        event.preventDefault();
        
        // Validate inputs
        if (!formData.first_name || !formData.last_name || !formData.email || !phone || !formData.password || !formData.password_confirmation || !formData.province || (account_type === 'business' && !formData.business_name)) {
            setErrorMessage("All fields are required.");
            setTimeout(() => setErrorMessage(""), 5000);
            return;
        }

        if (!validatePassword()) return;

        setLoading(true);
        setErrorMessage('');
        setSuccessMessage('');

        try {
            const { referral_code, ...restFormData } = formData;
            
            let clientData = { client: 'web' };
            if (Capacitor.isNativePlatform()) {
                try {
                    const info = await Device.getInfo();
                    const id = await Device.getId();
                    clientData = {
                        client: 'mobile',
                        device_name: info.name || info.model || 'Unknown Device',
                        device_id: id.identifier || 'Unknown ID',
                        platform: info.operatingSystem || 'unknown'
                    };
                } catch (deviceError) {
                    console.error("Failed to get device info:", deviceError);
                    clientData = {
                        client: 'mobile',
                        device_name: 'Unknown Device',
                        device_id: 'Unknown ID',
                        platform: Capacitor.getPlatform() || 'unknown'
                    };
                }
            }

            const userData = {
                ...restFormData,
                country: selectedCountry ? countryNames[selectedCountry] : "None",
                country_code: selectedCountry,
                phone: `+${phone}`,
                ...clientData,
                ...(referral_code ? { referral_code } : {}),
            };

            await registerUser(userData, dispatch);
            setSuccessMessage("Account created successfully! Check your email for OTP verification code.");
            toast.success("Account created successfully! Check your email for OTP verification code.");
            setTimeout(() => setSuccessMessage(""), 5000);
            
            setTimeout(() => {
                navigate('/otp', { state: { email: userData.email} });
            }, 2000);
        } catch (error) {
            const responseErrors = error?.response?.data?.errors;
            const fallbackMessage = error?.response?.data?.message || "Registration failed. Please try again.";
            
            if (responseErrors && Object.keys(responseErrors).length > 0) {
                const errorMessages = Object.values(responseErrors)
                .flat()
                .filter(Boolean); 

                setErrorMessage(errorMessages.length > 1 
                ? errorMessages[0] 
                : errorMessages.join("<br/>")
                );
                toast.error(errorMessages.length > 1 
                ? errorMessages[0] 
                : errorMessages.join("<br/>")
                );
            } else {
                toast.error(fallbackMessage);
                setErrorMessage(fallbackMessage);
            }
            setTimeout(() => setErrorMessage(""), 5000);  
            // console.error("Registration failed:", error); 
        } finally {
            setLoading(false);
        }
    };

    const currentCountry = supportedCountryDetails.find(
        (country) => country.iso2_code === selectedCountry
    );
    const states = currentCountry?.states || [];
    useEffect(() => {
        if (selectedCountry) {
            setStateLoading(true);
            
            const timer = setTimeout(() => {
                setStateLoading(false);
            }, 100);

            return () => clearTimeout(timer);
        }
    }, [selectedCountry]);

    if (!email || !account_type) {
        return null;
    }

    return (
        <div style={{ background: '#13053A', minHeight: '100vh' }}>
            <AuthHeader />
            <div className="auth__container reg__page padding__tb__30">
                <div className='auth__container__box'>
                    <div>
                        <Link to='/getstarted/email-verification'>
                            <FaArrowLeftLong className='auth__back__arrow' />
                        </Link>
                    </div>
                    <h3>{account_type === 'business' ? 'Business' : 'Personal'} Information</h3>
                    <p className='auth__text'>Fill out the following fields to proceed</p>
                    
                    <ProgressSteps currentStep={3} totalSteps={4} />
                    
                    <div className='auth__container__form w-full'>

                        <form onSubmit={handleSignup}>
                            <div className="row">
                                {account_type === 'business' && (
                                    <div className="col-12 col-lg-12">
                                        <div className='form__group mb-3'>
                                            <label className='label__form'>Business Name</label>
                                            <input type="text" name="business_name" className='auth__form__input' value={formData.business_name} onChange={handleChange} />
                                        </div>
                                    </div>
                                )}
                                <div className="col-12 col-lg-6">
                                    <div className='form__group mb-3'>
                                        <label className='label__form'>Legal First Name</label>
                                        <input type="text" name="first_name" className='auth__form__input' value={formData.first_name} onChange={handleChange} />
                                    </div>
                                </div>
                                <div className="col-12 col-lg-6">
                                    <div className='form__group mb-3'>
                                        <label className='label__form'>Legal Last Name</label>
                                        <input type="text" name="last_name" className='auth__form__input' value={formData.last_name} onChange={handleChange} />
                                    </div>
                                </div>
                                <div className="col-12 col-lg-6">
                                    <div className='form__group mb-3'>
                                        <label className='label__form'>{account_type === 'business' ? 'Location' : 'Where do you live?'}</label>
                                        <ReactFlagsSelect 
                                            selected={selectedCountry} 
                                            onSelect={setSelectedCountry} 
                                            customLabels={countryNames}
                                            countries={allowedCountryCodes}
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-lg-6">
                                    <div className='form__group mb-3'>
                                        <label className='label__form'>State/Province</label>
                                        <select
                                            name="province"
                                            className="auth__form__input"
                                            value={formData.province}
                                            onChange={handleChange}
                                            disabled={stateLoading}
                                        >
                                            {stateLoading ? (
                                                <option disabled value="">Loading states...</option>
                                            ) : states.length > 0 ? (
                                                <>
                                                    <option disabled value="">Select a state</option>
                                                    {states.map((stateItem) => (
                                                        <option key={stateItem.code || stateItem.id} value={stateItem.name}>
                                                            {stateItem.name}
                                                        </option>
                                                    ))}
                                                </>
                                            ) : (
                                                <option disabled value="">No states available</option>
                                            )}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-6">
                                    <div className='form__group mb-3'>
                                        <label className='label__form'>Phone Number</label>
                                        <PhoneInput
                                            country={selectedCountry?.toLowerCase() || 'ng'}
                                            value={phone}
                                            onChange={setPhone}
                                            onlyCountries={allowedCountries.map((country) => country.toLowerCase())}
                                            // enableSearch
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-lg-6">
                                    <div className='form__group mb-3'>
                                        <label className='label__form'>Referral Code <em>(Optional)</em></label>
                                        <input 
                                            type="text" name="referral_code" className='auth__form__input'
                                            value={formData.referral_code} onChange={handleChange}
                                            disabled={ref_code}
                                        />
                                    </div>
                                </div>
                                {/* <div className="col-12 col-lg-6">
                                    <div className='form__group mb-3'>
                                        <label className='label__form'>{formData.email}</label>
                                        <input type="text" name="account_type" className='auth__form__input' value={formData.account_type} disabled />
                                    </div>
                                </div> */}
                                <div className="col-12 col-lg-12">
                                    <div className='form__group mb-3'>
                                        <label className='label__form'>Password</label>
                                        <div className="input-group">
                                            <input type={passwordType} name="password" className='auth__form__input' value={formData.password} onChange={handleChange} />
                                            <span className='auth__input__group end__0' role="button" onClick={() => togglePasswordVisibility(setPasswordType, passwordType)}>
                                                {passwordType === 'password' ? <IoMdEyeOff /> : <IoEye />}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12">
                                    <div className="password-requirements mb-3 d-flex flex-wrap justify-content-center gap-2">
                                        {passwordCriteria.map(criteria => (
                                            <div key={criteria.id} className={`requirement-box ${criteria.isValid(formData.password) ? 'valid' : ''}`}>
                                                <LuFileText /> {criteria.text}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12">
                                    <div className='form__group mb-3'>
                                        <label className='label__form'>Confirm Password</label>
                                        <div className="input-group">
                                            <input type={passwordType} name="password_confirmation" className='auth__form__input' value={formData.password_confirmation} onChange={handleChange} />
                                            <span className='auth__input__group end__0' role="button" onClick={() => togglePasswordVisibility(setPasswordType, passwordType)}>
                                                {passwordType === 'password' ? <IoMdEyeOff /> : <IoEye />}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                
                            </div>

                            <div className='d-flex justify-content-start mb-3'>
                                <input type="checkbox" id='acceptTerms' className="" required />
                                <label htmlFor='acceptTerms' className='accept__terms'>
                                    By registering, you accept our <Link to={`${publicUrl}/legal`} target='_blank'>Terms of Use</Link> and <Link to={`${publicUrl}/privacy-policy`} target='_blank'>Privacy Policy</Link>
                                </label>
                            </div>

                            {errorMessage && <p className="text-center text-danger error-container">{errorMessage}</p>}
                            {successMessage && <p className="text-center text-success success-container">{successMessage}</p>}

                            <div className='form__group mb-5'>
                                <button type='submit' className='btn btn__block'>
                                    {loading ? (
                                        <div className="spinner-border spinner-border-sm text-light" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    ) : 'Continue'} 
                                </button>
                            </div>
                        </form>
                        
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PersonalInformation;